import $ from 'jquery'

// Loading Box (Preloader)
function handlePreloader() {
    // if ($('.preloader').length) {
    //     $('.preloader').delay(200).fadeOut(500);
    // }
}

// Header Style and Scroll to Top
function headerStyle() {
    if ($('.main-header').length) {
        var windowpos = $(window).scrollTop()
        // var siteHeader = $('.main-header')
        var scrollLink = $('.scroll-top')

        if (windowpos >= 250) {
            // siteHeader.addClass('fixed-header')
            scrollLink.fadeIn(300)
        } else {
            // siteHeader.removeClass('fixed-header')
            scrollLink.fadeOut(300)
        }
    }
}

$(window).on('scroll', function () {
    headerStyle()
})

const mobileWidth = 767

$(window).on('load', function () {

    handlePreloader()

    $('.navigation li.dropdown').hover(function () {
        if ($(window).innerWidth() >= mobileWidth) {
            $(this).children('ul').stop(true, false, true).slideToggle(300);
            // $(this).children('.megamenu').stop(true, false, true).slideToggle(300);
        }
    });
})

$(window).on('resize', function () {
    $('.navigation li.dropdown').children('ul').hide()
})

$(function () {
})